export const PICKUP_POINTS_FETCH_PICKUP_POINTS = "PICKUP_POINTS_FETCH_PICKUP_POINTS";
